(function() {
    'use strict';

    angular.module('app.tiposPlanilla', []);
})();
